<template>
  <div class="d2-plan-card-item" :class="{ 'current': plansListEData.plan_e_text == '使用中' || plansListEData.plan_e_text == 'Using' }">
    <div class="d2-plan-card-name">{{ plansListEData.plan_e_title }}</div>
    <div class="d2-plan-card-price-row"><span class="d2-plan-card-price">${{ plansListEData.plan_e_label_amount }}</span><span class="d2-plan-card-unit">/{{lang['components']['Plan']['PlanE']['time_unit']}}</span></div>
    <ul class="d2-plan-card-features">
      <li v-for="(item, index) in description">
          <i class="fas fa-check"></i> {{ item }}
      </li>
    </ul>
    <button v-if="plansListEData.plan_e_show" class="d2-plan-card-btn upgrade" @click="handleChickPlan(142, 'E', '', 'fb')">
      {{ plansListEData.plan_e_text }}
    </button>
    <button v-else-if="!plansListEData.planHaveBind" class="d2-plan-card-btn upgrade" @click="handleChickPlan(142, 'E', '', 'fb')">
      {{lang['components']['Plan']['PlanE']['is_expired']}}
    </button>
    <button
      v-else
      class="d2-plan-card-btn payagain"
      v-if="isExpiredData && (plansListEData.plan_e_text == '使用中' || plansListEData.plan_e_text == 'Using')"
      @click="handleChickPlan(142, 'E', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanE']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanE',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListE:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListEData: {
      get: function () {
        return this.plansListE
      },
      set: function (value) {
        this.$emit('update:plansListEData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListE.plan_e_description
    },
    isDisabled: function() {
       return this.plansListE.plan_e_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-E {
    &:hover {
      border: 2px #1D619F solid;
    }
  }
</style>
